module.exports = "mutation UpdateIssueMessage($data:UpdateIssueMessageInput!){updateIssueMessage(data:$data){success}}"